import { mapGetters, mapMutations } from 'vuex';
import vClickOutside from 'v-click-outside';
import Price from '~/components/helpers/Price';
import MyPreloader from '~/components/ui/MyPreloader';
export default {
    components: {
        Price,
        MyPreloader,
        SkeletonSearchResults: () => import('~/components/skeletons/SkeletonSearchResults.vue'),
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    data() {
        return {
            searchValue: '',
            debounce: null,
            isPreloaderSearch: false,
            isShowEmptyText: false,
        };
    },
    computed: {
        ...mapGetters({
            isNovaPorta: 'global/getIsNovaPorta',
            isUnitsMeasuresAllow: 'global/isUnitsMeasuresAllow',
            activeProductCount: 'global/getActiveProductCount',
        }),
        ...mapGetters('search', ['getModalShow', 'getBadges', 'getResults']),
        showResultsBlock() {
            return this.searchValue.length >= 2 && this.getResults.products.length > 0 && this.getModalShow;
        },
        currentLocaleCode() {
            let code = this.$i18n.locales.filter(i => i.code === this.$i18n.locale)[0].code;
            return code === 'ro' ? code + '/' : '';
        },
    },
    mounted() {
        if (this.$route.query.query) {
            this.searchValue = this.$route.query.query;
        }
    },
    methods: {
        ...mapMutations('search', [
            'setModalShow',
            'setBadges',
            'setSearchResultsProducts',
            'setResultsByCategory',
            'setTotalCount',
            'setIsSearching',
            // 'setStateSearch'
        ]),
        ...mapMutations({
            setStateSearch: 'setStateSearch',
        }),
        externalClickSearch(event) {
            if (
                ![
                    'search__input',
                    'searchForm',
                    'search',
                    'searchFormBtn',
                    'searchFormBtnEcom',
                    'update',
                    'showSearch',
                    'allSearchResults',
                ].includes(event.target.id)
            ) {
                this.setModalShow(false);
            }
        },
        clearSearchValue() {
            this.searchValue = '';
            this.setSearchResultsProducts([]);
            this.setTotalCount(0);
            this.setResultsByCategory([]);
            this.isShowEmptyText = false;
        },
        getTitle(product) {
            return product.title;
        },
        closeModalAndClearSearch() {
            this.setModalShow(false);
            this.clearSearchValue();
        },

        switchToProductPage(product) {
            this.setModalShow(false);
            this.$router.push({ path: this.localePath('/product/' + product?.url) });
        },

        bindBadge(badge) {
            this.searchValue = badge;
            this.debounceSearch();
        },
        async updateBadges() {
            let queries = await this.$axios.$get('general/popular_query/');
            if (queries.length) {
                const badges = queries.map(e => {
                    return e.query;
                });
                this.setBadges(badges);
            }
        },
        async search() {
            if (this.searchValue.length >= 2) {
                let results = await this.$axios.$get('general/v2/search/search/?query=' + this.searchValue);

                if (results.products?.length) {
                    this.setSearchResultsProducts(results.products.slice(0, 7));
                    this.setTotalCount(results.totalCount);
                    this.setResultsByCategory(results.resultsByCategory);
                } else {
                    this.isShowEmptyText = true;
                }
                this.isPreloaderSearch = false;
            } else {
                this.isPreloaderSearch = false;
            }
        },

        debounceSearch(e) {
            if (this.$route?.path === this.localePath('/search')) {
                let currentValue = e?.target?.value;
                setTimeout(async () => {
                    if (currentValue === this.searchValue) {
                        await this.$router.push({ query: { query: e.target.value } });
                    }
                }, 0);
            }
            this.isShowEmptyText = false;
            this.isPreloaderSearch = true;
            clearTimeout(this.debounce);
            this.setSearchResultsProducts([]);
            this.setTotalCount(0);
            this.debounce = setTimeout(async () => {
                await this.search();
            }, 600);
        },
        async goSearch() {
            await this.$router.push({ path: this.localePath('/search?query=') + this.searchValue });
            if (this.$refs?.search) {
                this.$refs.search.blur();
            }
            this.setModalShow(false);
            this.setStateSearch(false);
            this.searchValue = '';
            if (this.$refs?.farmacieSearchInput) this.$refs.farmacieSearchInput.blur();
            this.setIsSearching(true);
        },
        closeDesktopSearch() {
            this.searchValue = '';
        },
    },

    watch: {
        '$route.path': {
            handler() {
                this.searchValue = '';
            },
        },
        '$i18n.locale': async function () {
            await this.search();
        },
    },

    // async fetch() {
    //     let queries = await this.$axios.$get('general/popular_query/');
    //     if (queries.length) {
    //         const badges = queries.map(e => {
    //             return e.query;
    //         });
    //         this.setBadges(badges);
    //     }
    // },
    fetchOnServer: true,
    fetchKey: 'site-search',
};
